import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss'],
})
export class CompleteComponent implements OnInit {
  public title = '';
  public messeges = '';
  public src = '';
  public srcSp = '';
  public isLoading = false;
  public arrayPath: string[] = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.title = this.activatedRoute.snapshot.queryParams.title;
    if (this.activatedRoute.snapshot.queryParams.messege) {
      this.messeges =
        this.activatedRoute.snapshot.queryParams.messege.split('\n\r');
    }
    if (
      this.activatedRoute.snapshot.queryParams.src &&
      this.activatedRoute.snapshot.queryParams.srcSp
    ) {
      this.src = this.activatedRoute.snapshot.queryParams.src;
      this.srcSp = this.activatedRoute.snapshot.queryParams.srcSp;
    }

    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4]?.match(/jp/)) {
      this.translate.use('jp');
      this.translate.setDefaultLang('jp');
    } else {
      this.translate.use('en');
      this.translate.setDefaultLang('en');
    }
  }
}
